import { Component, Host, h } from "@stencil/core";

@Component({
  tag: "ls-history",
  styleUrl: "ls-history.css",
  shadow: true,
})
export class LsHistory {
  render() {
    return (
      <Host>
        <fieldset>
          <legend>ls-history</legend>
        </fieldset>
        <slot></slot>
      </Host>
    );
  }
}
